module.exports = __webpack_public_path__ + "img/ground-mountain-morning.f105a88d.png";